<template>
	<div>
		<b-modal v-model="modal" no-close-on-backdrop>
			<template #modal-header>
				<h5>{{ title }}</h5></template
			>
			<b-row>
				<b-col>
					<search-input
						ref="AccountPlanGroup"
						:form="form"
						:isLoading="isLoading"
						:name="'account_plan_group_id'"
						:searchResult="AccountPlanGroup"
						@selected="setAccountPlanGroup($event)"
						@search="searchAccountPlanGroup($event)"
						:alias="form.account_plan_group_id.alias"
						v-model="form.account_plan_group_id.value"
						:displayedValue="form.account_plan_group.value"
					>
						<search-input-option
							:key="index"
							:index="index"
							@click="setAccountPlanGroup(row)"
							v-for="(row, index) in AccountPlanGroup.data"
						>
							<div>
								{{ row.description }}
								<br />
							</div>
						</search-input-option>
					</search-input>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					<text-input
						ref="description"
						v-model="form.description.value"
						:form="form"
						:name="'description'"
						:alias="form.description.alias"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<text-input
						ref="code"
						v-model="form.code.value"
						:form="form"
						:name="'code'"
						:alias="form.code.alias"
					/>

					<!-- <text-input :alias="form.code.alias" v-model="form.code.value" /> -->
				</b-col>
			</b-row>
			<b-form-checkbox
				switch
				v-model="form.status.value"
				:value="1"
				:unchecked-value="0"
			>
				<span style="cursor:pointer">{{
					form.status.text[form.status.value]
				}}</span>
			</b-form-checkbox>
			<template #modal-footer>
				<button
					class="btn btn-outline-secondary"
					role="button"
					tabindex="-1"
					@click="modal = false"
				>
					<i class="fas fa-times"></i> Cancelar
				</button>
				<button
					role="button"
					style="margin-left: 5px"
					class="btn btn-success ml-2"
					@click="store()"
				>
					<i class="fas fa-check"></i> Salvar
				</button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import Form from "../../../mixins/Form";

	export default {
		data() {
			return {
				id: null,
				title: null,
				modal: false,
				isLoading: false,
				form: new Form({
					id: {
						value: null
					},
					account_plan_group: {},
					code: {
						value: null,
						alias: 'Codigo ',
						validate: {
							required: true
						},
					},

					description: {
						alias: "Descrição",
						validate: {
							required: true,
						},
					},

					account_plan_group_id: {
						validate: {
							required: true,
						},
						alias: "Grupo de plano de conta"
					},
					status: {
						alias: "Status",
						default: 1,
						text: {
							1: "Este cadastro está ativo",
							0: "Este cadastro está inativo"
						}
					}
				})
			}
		},

		computed: {
			accountPlan() {
				return this.$store.state.accountPlan.accountPlan
			},
			AccountPlanGroup() {
				return this.$store.state.accountPlan.accountsPlanGroups;
			},
		},

		methods: {
			open(id) {
				this.form.reset();
				this.$store.commit("showLoading");

				if (id != null) {
					this.$store
						.dispatch("accountPlan/getAccountPlan", id)
						.then(response => {

							this.form.account_plan_group.value = this.accountPlan.group_description
							this.form.setValues(this.accountPlan);
							this.title = 'Editar Plano de contas'
							this.$store.commit("hideLoading");
							this.modal = true

						}).catch(error => {
							console.log(error)
						});
				}
				if (id == null) {
					this.title = 'Novo Plano de contas'
					this.$store.commit("hideLoading");
					this.modal = true
				}
			},

			setAccountPlanGroup(account_plan_group) {
				this.form.account_plan_group_id.value = account_plan_group.id;
				this.form.account_plan_group.value = account_plan_group.description;
			},

			searchAccountPlanGroup(search) {
				this.isLoading = true
				this.$store.dispatch("accountPlan/getAccountsPlanGroups", search)
					.then(response => {
						this.isLoading = false
					})
					.catch(error => {
						this.isLoading = false
						this.error = error;
					});
			},

			store() {
				if (this.form.isValid()) {

					if (this.form.id.value) {
						this.update()
					}
					else {
						this.newAccountPlan()
					}
				}
			},

			newAccountPlan() {
				this.$store.commit("showLoading");
				this.$store
					.dispatch("accountPlan/storeAccountPlan", this.form.getValues())
					.then(response => {

						this.modal = false
						this.$emit('store')
						this.$store.commit("hideLoading");

					}).catch(error => {

						this.modal = false
						this.$emit('store')
						this.$store.commit("hideLoading");

					});
			},

			update() {
				this.$store.commit("showLoading");
				this.$store
					.dispatch("accountPlan/updateAccountPlan", {
						params: this.form.getValues(), id: this.form.id.value
					})
					.then(response => {

						this.modal = false
						this.$emit('store')
						this.$store.commit("hideLoading");

					}).catch(error => {

						this.modal = false
						this.$emit('store')
						this.$store.commit("hideLoading");

					});
			}
		},
	}
</script>
<style>

</style>